// extracted by mini-css-extract-plugin
export default {"profileHeaderWrapper":"ProfileHeader_profileHeaderWrapper__hPk5n","addButton":"ProfileHeader_addButton__YNEGj","removeButton":"ProfileHeader_removeButton__GcqiR"};